import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { setContinueButtonText } from 'store/CustomReports/actions'
import { resetSelectedRoles } from 'store/CustomReports/actions'
import { setContinueDisabled } from 'store/CustomReports/actions'
import { setCourseRolesAndRoleGroups } from 'store/CustomReports/actions'
import { wait } from 'utils/helpers'
import { SlideHeader } from './SlideHeader'
import { NavLink } from 'reactstrap'
import Search from './Search'
import FilterSelectedOnly from './FilterSelectedOnly'
import { setSelectedRoles } from 'store/CustomReports/actions'
import _ from 'lodash'
import { setCourseGroupRolesAndRoleGroups } from 'store/CustomReports/actions'

export default function RoleFiltering({ roles, roleGroups }) {
  const dispatch = useDispatch()

  const {
    selectedRoles: { roles: selectedRoles, type },
    showSelectedOnly,
    editingReport,
    selectedReportType,
  } = useSelector((store) => store.customReports)

  const [activeTab, setActiveTab] = useState(0)
  const [searchValue, setSearchValue] = useState('')

  const [filteredRoles, setFilteredRoles] = useState([])

  const changeTab = (tab) => {
    setActiveTab(tab)
    setSearchValue('')
  }

  useEffect(() => {
    if (selectedReportType === 0) {
      dispatch(setCourseRolesAndRoleGroups())
    } else {
      dispatch(setCourseGroupRolesAndRoleGroups())
    }
  }, [dispatch, selectedReportType])

  useEffect(() => {
    if (activeTab === 0) {
      setFilteredRoles(
        roles?.length
          ? roles.filter((role) =>
              role?.name
                ?.toLowerCase()
                ?.includes(searchValue.trim().toLowerCase())
            )
          : []
      )
    }

    if (activeTab === 1) {
      setFilteredRoles(
        roleGroups?.length
          ? roleGroups.filter((role) =>
              role.name.toLowerCase().includes(searchValue.trim().toLowerCase())
            )
          : []
      )
    }
  }, [searchValue, activeTab, roles, roleGroups])

  useEffect(() => {
    if (editingReport) {
      if (
        _.isEqual(
          _.sortBy(roles.map((role) => role.id)),
          _.sortBy(selectedRoles)
        )
      ) {
        dispatch(resetSelectedRoles())
      }
    }
  }, [editingReport, roles, selectedRoles, dispatch])

  useEffect(() => {
    wait(() => {
      dispatch(setContinueDisabled(false))
      if (!selectedRoles?.length) {
        dispatch(setContinueButtonText('Skip'))
      } else {
        dispatch(setContinueButtonText('Continue'))
      }
    })
  }, [dispatch, selectedRoles?.length])

  return (
    <>
      <SlideHeader
        header='Filter by Role or Role Groups'
        helper='(Not adding any filters will simply apply all roles)'
      />

      <div className='border p-4 mx-auto single-course-container scrollbar'>
        <div className='d-flex align-items-center mb-4'>
          <div className='settings-tabs switch-tabs mx-auto d-flex py-1 mb-0'>
            <NavLink
              activeClassName='current'
              className={activeTab === 0 ? 'current' : ''}
              onClick={() => changeTab(0)}
            >
              Roles
            </NavLink>
            <NavLink
              activeClassName='current'
              className={activeTab === 1 ? 'current' : ''}
              onClick={() => changeTab(1)}
            >
              Role Groups
            </NavLink>
          </div>
          <Search
            placeholder={
              activeTab === 0 ? 'Search for a role' : 'Search for a role group'
            }
            value={searchValue}
            setValue={setSearchValue}
            width='w-50'
            marginBottom='mb-0'
          />
        </div>
        <FilterSelectedOnly items={selectedRoles} />

        {filteredRoles && filteredRoles.length
          ? filteredRoles.map((role) => {
              const isSelected = selectedRoles?.includes(role.id)
              return (
                <div
                  key={role.id}
                  className={`custom-control custom-checkbox mb-3 ${
                    !isSelected && showSelectedOnly && 'd-none'
                  }`}
                  style={{ zIndex: '0' }}
                >
                  <input
                    value={role.id}
                    className='custom-control-input'
                    id={role.id}
                    checked={isSelected}
                    onChange={(e) => {
                      if (selectedRoles.length) {
                        if (type !== activeTab) dispatch(resetSelectedRoles())
                      }
                      dispatch(setSelectedRoles(+e.target.value, activeTab))
                    }}
                    type='checkbox'
                  />
                  <label className='custom-control-label' htmlFor={role.id}>
                    {role.name}
                  </label>
                </div>
              )
            })
          : null}
      </div>
    </>
  )
}
